module.exports = __webpack_public_path__ + "static/IMG_2255-2d485093df632efef1bfeae83b63516d.jpg";